import React from 'react';
import Topbar from './Topbar';
import Sidebar from './Sidebar';
import { useData } from '../context/DataContext';
import { useAuth, hasModule } from '../context/AuthContext';
import { useModule } from '../App';
import Dashboard from './modules/Dashboard';
import Contacts from './modules/Contacts';
import Companies from './modules/Companies';
import Email from './modules/Email';
import Pipeline from './modules/Pipeline';
import Marketing from './modules/Marketing';
import Documents from './modules/Documents';
import Reports from './modules/Reports';
import Settings from './modules/Settings';
import Payments from './modules/Payments';
import Forms from './modules/Forms';
import Products from './modules/Products';
import Orders from './modules/Orders';
import Funnels from './modules/Funnels';
import Website from './modules/Website';
import Leads from './modules/Leads';
import Tasks from './modules/Tasks';
import CalendarModule from './modules/Calendar';
import LoanQuotes from './modules/LoanQuotes';
import SecureCX from './modules/SecureCX';

const MODULE_COMPONENTS = {
  dashboard: Dashboard, leads: Leads, contacts: Contacts, companies: Companies, email: Email, pipeline: Pipeline,
  marketing: Marketing, documents: Documents, reports: Reports,
  settings: Settings, payments: Payments, forms: Forms,
  products: Products, orders: Orders, funnels: Funnels, website: Website,
  tasks: Tasks, calendar: CalendarModule, quotes: LoanQuotes, securecx: SecureCX,
};

const Shell = () => {
  const { currentLob, lobs, loading, lobsError, reloadLobs } = useData();
  const { user } = useAuth();
  const { currentModule, setCurrentModule } = useModule();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  React.useEffect(() => {
    if (!hasModule(user, currentModule)) {
      const fallback = ['dashboard', 'leads', 'contacts', 'pipeline', 'quotes', 'forms', 'tasks', 'calendar', 'funnels', 'reports', 'payments', 'marketing', 'email', 'documents', 'settings'].find((m) => hasModule(user, m));
      if (fallback && fallback !== currentModule) setCurrentModule(fallback);
    }
  }, [user, currentModule, setCurrentModule]);

  // Close mobile sidebar on module change
  React.useEffect(() => { setMobileOpen(false); }, [currentModule, currentLob?.id]);

  const Active = MODULE_COMPONENTS[currentModule] || Dashboard;
  const needsLob = !['settings', 'tasks', 'calendar'].includes(currentModule);

  return (
    <div className="crm-shell">
      <Topbar onToggleSidebar={() => setMobileOpen((o) => !o)} />
      <div className="crm-body">
        {mobileOpen && <div className="crm-mobile-overlay" onClick={() => setMobileOpen(false)} data-testid="mobile-overlay" />}
        <div className={mobileOpen ? 'sidebar-wrap mobile-show' : 'sidebar-wrap'}>
          <Sidebar mobileOpen={mobileOpen} />
        </div>
        <div className="crm-main">
          {loading ? (
            <div className="empty-state" data-testid="data-loading"><div className="ttl">Loading…</div><div className="sub">Fetching your business lines.</div></div>
          ) : lobsError ? (
            <div className="empty-state" data-testid="lobs-error-state">
              <div className="ttl">Couldn't load your business lines</div>
              <div className="sub">This is usually a temporary connection hiccup, not a data problem.</div>
              <button className="dp-btn primary" style={{ marginTop: 12 }} onClick={reloadLobs} data-testid="lobs-retry-btn">Retry</button>
            </div>
          ) : needsLob && (!currentLob || lobs.length === 0) ? (
            <div className="empty-state" data-testid="no-lob-state"><div className="ttl">No business line accessible</div><div className="sub">Ask your super admin to assign you to a business line.</div></div>
          ) : (
            <div key={needsLob ? `${currentLob?.id || 'no-lob'}-${currentModule}` : currentModule} className="module-enter" style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
              <Active lob={currentLob} lobKey={currentLob?.key} />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Shell;
